<div class="container-fluid">
  <div class="row">
    <div class="col">
      <button
        (click)="addPlaylistButtonClicked()"
        id="addPlaylistButton"
        class="side-menu-button2 w-100 me-3"
      >
        + Playlist
      </button>
    </div>
  </div>

  <p-table
    id="playlists"
    [value]="filteredPlaylists()"
    #dt
    dataKey="ID"
    [tableStyle]="{ width: '100%' }"
    [loading]="isLoading"
    [rows]="25"
    [totalRecords]="getTotalPlaylistsCount()"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first}-{last} of {totalRecords} items"
    paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="true"
    [responsive]="true"
    [resizableColumns]="true"
    styleClass="p-datatable-sm"
    [scrollable]="true"
    [scrollHeight]="'flex'"
  >
    <ng-template pTemplate="caption">
      <div class="container text-center" id="playlistsCaption">
        <!-- Search Row -->
        <div class="row mb-3">
          <div class="col">
            <span class="p-input-icon-left w-100">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                class="w-100"
                placeholder="Playlist Name"
                id="searchBarInput"
                (ngModelChange)="exitEditModeIfActive()"
                [(ngModel)]="searchKeyword"
              />
            </span>
          </div>
        </div>

        <!-- Collapsible Filters Row -->
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex align-items-center">
              <button
                id="filtersButton"
                type="button"
                class="btn btn-link p-0 me-2"
                (click)="toggleFiltersCollapsed()"
                [attr.aria-expanded]="!filtersCollapsed()"
                aria-controls="filtersCollapse"
                style="font-size: 1.2rem; font-weight: bold; color: #719eb6; text-decoration: none;"
              >
                <i class="pi" [class.pi-chevron-right]="filtersCollapsed()" [class.pi-chevron-down]="!filtersCollapsed()"></i>
                Filters
              </button>
            </div>
            
            <div class="collapse" [class.show]="!filtersCollapsed()" id="filtersCollapse">
              <div class="row mt-3">
                <div class="col">
                  <p-multiSelect
                    appendTo="body"
                    [group]="true"
                    [options]="possibleFilters()"
                    name="selectedFilters"
                    [(ngModel)]="selectedFilters"
                    display="chip"
                    [showClear]="true"
                    placeholder="Select Filters"
                    styleClass="w-100"
                    [style]="{ width: '100%' }"
                  >
                    <ng-template let-group pTemplate="group">
                      <div class="flex align-items-center">
                        <span>{{ group.label }}</span>
                      </div>
                    </ng-template>
                    <ng-template let-item pTemplate="footer">
                      <div class="py-2 px-3">
                        <b>
                          {{ selectedFilters().length }}
                        </b>
                        item{{ selectedFilters().length > 1 ? "s" : "" }}
                        selected.
                      </div>
                    </ng-template>
                  </p-multiSelect>
                </div>
              </div>
              <div class="row mb-3 mt-3">
                <div class="col-12">
                  <div class="d-flex flex-wrap gap-3 justify-content-end">
      
                    @if(!includeDeleted()) {
                    <p-button
                      id="includeDeletedButton"
                      [style]="{
                        color: 'red',
                        backgroundColor: 'white',
                        border: '2px solid red',
                        'border-radius': '10px'
                      }"
                      label="Include Deleted"
                      icon="pi pi-trash"
                      (onClick)="toggleIncludeDeleted()"
                    />
                    } @else {
                    <p-button
                      [style]="{
                        color: 'white',
                        backgroundColor: 'red',
                        border: '2px solid white',
                        'border-radius': '10px'
                      }"
                      label="Exclude Deleted"
                      icon="pi pi-trash"
                      (onClick)="toggleIncludeDeleted()"
                    />
                    }
      
                    <p-button
                      label="Clear"
                      [style]="{
                        'border-radius': '10px',
                        border: '2px solid #719eb6'
                      }"
                      icon="pi pi-filter-slash"
                      (click)="clearSearch()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Order and Selection Row -->
        <div class="row mb-3">
          <div class="col-5">
            <div class="d-flex flex-wrap gap-3 align-items-center">
              <!-- Edit/Done button (only shown when custom order is selected) -->
              @if(orderMode() === 'custom') {
              <p-button
                [label]="isEditMode() ? 'Save' : 'Edit'"
                [icon]="isEditMode() ? 'pi pi-check' : 'pi pi-pencil'"
                [style]="{
                  'border-radius': '10px',
                  border: '2px solid #28a745',
                  color: isEditMode() ? 'white' : '#28a745',
                  backgroundColor: isEditMode() ? '#28a745' : 'white'
                }"
                (onClick)="toggleEditMode()"
              />
              }
              
              <!-- Order dropdown -->
              <div class="d-flex align-items-center gap-2">
                <label style="font-size: 1rem; font-weight: bold; color: #719eb6; margin: 0;">Order:</label>
                <p-dropdown
                  [options]="orderOptions()"
                  [(ngModel)]="orderMode"
                  (ngModelChange)="onOrderModeChange()"
                  optionLabel="label"
                  optionValue="value"
                  [style]="{
                    'min-width': '150px',
                    'border-radius': '10px'
                  }"
                />
              </div>
            </div>
          </div>
          <div class="col-7">
            <div class="d-flex flex-wrap gap-3 justify-content-end">
              @if(!selectingForDeletion){
                <p-button
                label="Select Playlists"
                [style]="{
                  backgroundColor: 'white',
                  color:'#719eb6',
                  'border-radius': '10px',
                  border: '2px solid #719eb6'
                }"
                icon="pi pi-wrench"
                (click)="toggleIsSelecting()"
              />
              }
              @else {
              <p-button
                label="Select All"
                [style]="{
                  backgroundColor: 'white',
                  color:'#719eb6',
                  'border-radius': '10px',
                  border: '2px solid #808080'
                }"
                icon="pi pi-check-square"
                (click)="selectAllPlaylists()"
              />
              <p-button
                [style]="{
                  color: 'red',
                  backgroundColor: 'white',
                  border: '2px solid red',
                  'border-radius': '10px'
                }"
                label="Delete Playlists"
                icon="pi pi-trash"
                [disabled]="playlistIDsForDeletion.length === 0"
                (onClick)="deleteSelectedPlaylists()"
              />
              <p-button
                label="Cancel"
                [style]="{
                  backgroundColor: 'white',
                  color:'#719eb6',
                  'border-radius': '10px',
                  border: '2px solid #808080'
                }"
                icon="pi pi-minus-circle"
                (click)="cancelIsSelecting()"
              />
              }
            </div>
          </div>
        </div>

      </div>
    </ng-template>
    <ng-template pTemplate="body" let-playlist>
      @if(orderMode() === 'custom' && isEditMode()) {
      <!-- Edit mode with overlay -->
      <tr class="edit-row">
        <td colspan="100%" class="p-0">
          <div class="edit-container" [id]="'edit-container-' + playlist.ID">
            <!-- Playlist content -->
            <div class="playlist-content">
              <app-playlist
                [patientID]="patientID()"
                [playlist]="playlist"
                [id]="playlist.PlaylistName"
                [isExpanded]="isExpandedStatus[playlist.ID]"
                [orderMode]="orderMode()"
                [isEditMode]="isEditMode()"
                (isExpandedChange)="onPlaylistExpandedChange(playlist.ID, $event)"
                (moveUp)="movePlaylistUp($event)"
                (moveDown)="movePlaylistDown($event)"
                (moveToTop)="movePlaylistToTop($event)"
                (moveToBottom)="movePlaylistToBottom($event)"
                [programExpandedStatus]="expansionState.programs"
                [targetExpandedStatus]="expansionState.targets"
                (programExpandedChange)="onProgramExpandedChange($event.programId, $event.isExpanded)"
                (targetExpandedChange)="onTargetExpandedChange($event.targetId, $event.isExpanded)"
                [isSelecting]="selectingForDeletion"
                [selectAll]="doSelectAll"
                (selectPlaylist)="selectPlaylist($event)"
              />
            </div>
            
            <!-- Semi-transparent overlay with arrows -->
            <div class="arrow-overlay" [class.moved]="hasPendingChanges(playlist.ID!)">
              <div class="arrow-row">
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="movePlaylistToTop(playlist.ID!)"
                  [disabled]="isFirstPlaylist(playlist.ID!)"
                  title="Move to top">
                  <i class="pi pi-angle-double-up"></i>
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="movePlaylistUp(playlist.ID!)"
                  [disabled]="isFirstPlaylist(playlist.ID!)"
                  title="Move up one">
                  <i class="pi pi-angle-up"></i>
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="movePlaylistDown(playlist.ID!)"
                  [disabled]="isLastPlaylist(playlist.ID!)"
                  title="Move down one">
                  <i class="pi pi-angle-down"></i>
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="movePlaylistToBottom(playlist.ID!)"
                  [disabled]="isLastPlaylist(playlist.ID!)"
                  title="Move to bottom">
                  <i class="pi pi-angle-double-down"></i>
                </button>
              </div>
            </div>
          </div>
        </td>
      </tr>
      } @else {
      <!-- Normal mode -->
      <app-playlist
        [patientID]="patientID()"
        [playlist]="playlist"
        [id]="playlist.PlaylistName"
        [isExpanded]="isExpandedStatus[playlist.ID]"
        [orderMode]="orderMode()"
        [isEditMode]="isEditMode()"
        (isExpandedChange)="onPlaylistExpandedChange(playlist.ID, $event)"
        (moveUp)="movePlaylistUp($event)"
        (moveDown)="movePlaylistDown($event)"
        (moveToTop)="movePlaylistToTop($event)"
        (moveToBottom)="movePlaylistToBottom($event)"
        [programExpandedStatus]="expansionState.programs"
        [targetExpandedStatus]="expansionState.targets"
        (programExpandedChange)="onProgramExpandedChange($event.programId, $event.isExpanded)"
        (targetExpandedChange)="onTargetExpandedChange($event.targetId, $event.isExpanded)"
        [isSelecting]="selectingForDeletion"
        [selectAll]="doSelectAll"
        (selectPlaylist)="selectPlaylist($event)"
      />
      }
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <p
        style="
          text-align: center;
          margin-top: 20px;
          font-size: 1rem;
          color: #719eb6;
        "
      >
        There are no playlists yet.
      </p>
    </ng-template>
  </p-table>
</div>
